@if (order) {
    <account-page title="Order #{{order.id}}">
        <card-component>
            <card-content>
                <h4>Status: <span [ngStyle]="{ color: statusColour }">{{ orderStatus }}</span></h4>
                <h4>Total: <base-currency-component
                    [currency]="order.currency"
                    [value]="order.total"
                    [locale]="systemConfigService.config.locale"
                    [precision]="order.currency_precision"
                ></base-currency-component></h4>
                <h4>Paid: <base-currency-component
                    [currency]="order.currency"
                    [value]="order.amount_paid"
                    [locale]="systemConfigService.config.locale"
                    [precision]="order.currency_precision"
                ></base-currency-component></h4>
                <h4>Outstanding: <base-currency-component
                    [currency]="order.currency"
                    [value]="order.total - order.amount_paid"
                    [locale]="systemConfigService.config.locale"
                    [precision]="order.currency_precision"
                ></base-currency-component></h4>
                <h4>Reference: {{ order.reference }}</h4>
            </card-content>
        </card-component>
        <card-component [styles]="{ 'margin-top': '20px' }">
            <card-content>
                <order-tab-view [order]="order"></order-tab-view>
            </card-content>
        </card-component>
    </account-page>
} @else {
    <app-loader [loading]="true" height="100px"></app-loader>
}
